export default __webpack_public_path__ + "static/media/sortOnlyTop.15413886.svg";